export function getPostsForPage(pageNumber: number, size, array) {
  const startIndex = pageNumber * size; // индекс первого поста на странице
  const endIndex = startIndex + size; // индекс последнего поста на странице
    return array.slice(startIndex, endIndex); // возвращает массив постов для текущей страницы
}
